// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type ExportMutationVariables = Types.Exact<{
  request?: Types.InputMaybe<Types.OcExportCreateModelInput>;
}>;

export type ExportMutation = { export: { __typename: 'ExportResponseModel'; id?: number | null } };

export const ExportDocument = gql`
    mutation Export($request: OcExportCreateModelInput) {
  export(request: $request) {
    id
    __typename
  }
}
    ` as unknown as DocumentNode<ExportMutation, ExportMutationVariables>;
